import { useRouter } from "next/router";
import { FC, useEffect } from "react";

import { storeIsLeadFromDrSmile } from "./helpers";

export const DrSmileService: FC<{}> = () => {
    const { asPath } = useRouter();

    useEffect(() => {
        const { drSmile } = Object.fromEntries(
            new URLSearchParams(asPath.split("?")[1])
        );

        if (drSmile) {
            storeIsLeadFromDrSmile();
        }
    }, [asPath]);

    return null;
};
